export default __webpack_public_path__ + "resources/icons/d200-0302.webp";